// extracted by css-extract-rspack-plugin
var _1 = "DragPerformanceFix-m_dragPerfFix-cy3e7gmE";
var _2 = "DragPerformanceFix-m_dragPerfShow-bLzMJWuq";
export { _1 as "dragPerfFix", _2 as "dragPerfShow" }
